import React from 'react';

interface SafeJsonLdProps {
  data: Record<string, any>;
}

const SafeJsonLd: React.FC<SafeJsonLdProps> = ({ data }) => {
  // Validate and sanitize JSON-LD data
  const sanitizeValue = (value: any): any => {
    if (typeof value === 'string') {
      // Remove potentially dangerous characters and scripts
      return value
        .replace(/<script[^>]*>.*?<\/script>/gi, '')
        .replace(/javascript:/gi, '')
        .replace(/on\w+\s*=/gi, '');
    }
    if (Array.isArray(value)) {
      return value.map(sanitizeValue);
    }
    if (value && typeof value === 'object') {
      const sanitized: Record<string, any> = {};
      for (const [key, val] of Object.entries(value)) {
        sanitized[key] = sanitizeValue(val);
      }
      return sanitized;
    }
    return value;
  };

  const sanitizedData = sanitizeValue(data);
  
  // Validate required JSON-LD structure
  if (!sanitizedData['@context'] || !sanitizedData['@type']) {
    console.warn('Invalid JSON-LD structure: missing @context or @type');
    return null;
  }

  try {
    // Validate that it's proper JSON
    JSON.stringify(sanitizedData);
  } catch (error) {
    console.error('Invalid JSON-LD data:', error);
    return null;
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(sanitizedData) }}
    />
  );
};

export default SafeJsonLd;